import Content from "components/Content";
import Label from "components/Label";
import React, { FC } from "react";

import styles from "./styles.module.scss";

interface Props {
  title: string;
  description?: string;
  image?: string;
  date?: string;
  author?: string;
}

const Heading: FC<Props> = ({ title, description, image, date, author }) => {
  return (
    <div className={styles.wrapper}>
      <img
        className={styles.hero}
        src={image || "/blog/header.jpg"}
        alt="Header"
      />
      <Content contentClassName={styles.container}>
        <Label className={styles.title} variant="h1-centered" color="white">
          {title}
        </Label>
        {description && (
          <Label
            className={styles.subtitle}
            variant="s2-centered"
            color="white"
          >
            {description}
          </Label>
        )}
        {(date || author) && (
          <div className={styles.byline}>
            {date && (
              <Label
                variant="s-capitalized"
                color="white"
                className={styles.date}
              >
                {new Date(date).toLocaleString("en-US", { dateStyle: "long" })}
              </Label>
            )}
            {author && (
              <Label
                variant="s-capitalized"
                color="white"
                className={styles.author}
              >
                {`by ${author}`}
              </Label>
            )}
          </div>
        )}
      </Content>
    </div>
  );
};

export default Heading;
